angular
    .module('app')
    .component('cacs', {
        templateUrl: '/templates/pages/cacs/cacs.html',
        controller: 'CacsController',
        controllerAs: 'vm',
    });